export const isBuildTime = () => {
    // POZOR: env promenna se musi ziskat timto zpusobem, aby nebyla nahrazena v buildtime
    const { NEXT_BUILD } = process.env;

    return !!NEXT_BUILD;
};
